export default {
    "/check": {
        show_in_menu: false,
        render_in_route: true
    },
    /* "/cabinet": {
        show_in_menu: true,
        render_in_route: true
    },
    "/cabinet/documents": {
        show_in_menu: false,
        render_in_route: true
    }, */
    // "/group/:id/dashboard": {
    //     show_in_menu: false,
    //     render_in_route: true
    // },
    // "/groups/:id/card/:page/:tab": {
    //     show_in_menu: false,
    //     render_in_route: true
    // },
    "/irtech": {
        show_in_menu: false,
        render_in_route: true
    },
    "/irtech/": {
        show_in_menu: false,
        render_in_route: true
    },
    "/irtech-monitoring": {
        show_in_menu: false,
        render_in_route: true
    },
    "/irtech-monitoring/": {
        show_in_menu: false,
        render_in_route: true
    },
    "/irtech-monitoring/monitorings": {
        show_in_menu: false,
        render_in_route: true
    }
}